import { ScrollReveal
} from "./ScrollReveal";
import { Building, Target, BarChart3, Wallet, BadgeCheck, Users
} from "lucide-react";
import { motion
} from "framer-motion";

const features = [
  { icon: Building, title: "Property Management", desc: "List, organize, and manage all your properties from one dashboard."
},
  { icon: Target, title: "Requirements", desc: "Capture and track requirements automatically. Never miss a potential deal."
},
  { icon: BarChart3, title: "Builder Projects", desc: "Real-time builder projects to optimize your deal pipeline."
},
  { icon: Wallet, title: "Staff Management", desc: "Add, Remove and Manage Staff Seamlessly."
},
  { icon: BadgeCheck, title: "Verified Listings", desc: "Every property is verified for trust, accuracy, and quality."
},
  { icon: Users, title: "Broker Network", desc: "Connect and collaborate with a growing network of trusted brokers."
},
];

const FeaturesSection = () => (
  <section id="features" className="section-light py-20 sm:py-28">
    <div className="container mx-auto px-4 sm:px-6">
      <ScrollReveal>
        <p className="text-xs font-medium uppercase tracking-[0.15em] text-muted-foreground text-center mb-3">
          Features
        </p>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center mb-4 text-foreground">
          Everything You Need to{" "}
          <span className="gradient-text font-extrabold">Close Deals Faster</span>
        </h2>
        <p className="text-center text-muted-foreground mb-14 max-w-md mx-auto text-sm leading-relaxed">
          Powerful tools designed for modern real estate professionals.
        </p>
      </ScrollReveal>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 max-w-4xl mx-auto">
        {features.map((f, i) => (
          <ScrollReveal key={i} delay={i * 0.06}>
            <motion.div
              whileHover={{ y: -3
}}
              className="p-5 sm:p-6 rounded-2xl bg-background border border-border hover:border-primary/15 transition-all duration-300 hover:shadow-lg hover:shadow-primary/5 group"
            >
              <div className="w-10 h-10 rounded-xl bg-primary/[0.07] flex items-center justify-center mb-3.5 group-hover:bg-primary/[0.12] transition-colors">
                <f.icon className="w-5 h-5 text-primary" />
              </div>
              <h3 className="font-semibold text-sm text-foreground mb-1.5">{f.title}</h3>
              <p className="text-xs text-muted-foreground leading-relaxed">{f.desc}</p>
            </motion.div>
          </ScrollReveal>
        ))}
      </div>
    </div>
  </section>
);

export default FeaturesSection;
